import { z } from 'zod';

/**
 * F34 — trainer-PRIVATE notes about a client. One editable note per
 * (trainer, client) pair. AuthZ is strict: ONLY the owning trainer ever reads
 * or writes their own note; it is never surfaced to the client or any other
 * trainer. RDS at-rest encryption only (no app-level crypto — the F30 D25
 * precedent).
 */

export const CLIENT_NOTE_BODY_MAX = 4000;

export type ClientNote = {
  readonly id: string;
  readonly trainerUserId: string;
  readonly clientUserId: string;
  readonly body: string;
  readonly countryCode: string;
  readonly createdAt: string;
  readonly updatedAt: string;
};

/** PUT upserts the single note for the (trainer, client) pair. */
export const UpsertClientNoteInputSchema = z
  .object({ body: z.string().min(1).max(CLIENT_NOTE_BODY_MAX) })
  .strict();
export type UpsertClientNoteInput = z.infer<typeof UpsertClientNoteInputSchema>;
